import React, {useState, useEffect} from 'react';
import {
  SortableContainer,
  SortableElement,
  arrayMove,
} from 'react-sortable-hoc';
import {styled} from '@mui/material/styles';
import {List, ListItem, ListItemText, IconButton} from '@mui/material';

const ApprovalLineGroup = styled(ListItem)({
  position: 'relative',
  minWidth: 300,
  margin: '5px 0',
  border: '1px solid #eee',
  zIndex: 9999,
  cursor: 'move!important',
  fontSize: 13,
  backgroundColor: '#00000014',
  '&:hover': {
    '& .add-btn': {
      opacity: 1,
    },
  },
  '&:first-of-type': {
    cursor: 'default',
    backgroundColor: '#00000014',
  },
});

const SortableItem = SortableElement(({value, deleteItem}) => {
  return (
    <ApprovalLineGroup variant="outlined">
      <ListItemText id={value.path} primary={value.name} sx={{m: 0, wordBreak: 'break-all', pr: 2}} />  
        <IconButton
          sx={{
            position: 'absolute',
            right: 0,
            fontSize: 15,
            '&:hover': {color: '#000'},
          }}
          onClick={deleteItem}
        >
          ⅹ
        </IconButton>
    </ApprovalLineGroup>
  );
});

const SortableList = SortableContainer(({items, deleteItem}) => {
  return (
    <div className="sortableHelper">
      <List dense sx={{p: 0, zIndex: 2}} onClick={e => e.stopPropagation()}>
        {items.map((value, index) => {
          return (
          <SortableItem
            key={index}
            index={index}
            value={value}
            deleteItem={() => deleteItem(index)}
          />
        )})}
      </List>
    </div>
  );
});

const Sortable = ({list, changeList, deleteItem}) => {
  const [items, setItems] = useState(list);

  const onSortEnd = ({oldIndex, newIndex}) => {
    const updatedItems = arrayMove(items, oldIndex, newIndex);
    setItems(updatedItems);
    changeList(updatedItems);
  };

  useEffect(() => {
    setItems(list);
  }, [list]);

  return (
    <SortableList
      items={items}
      onSortEnd={onSortEnd}
      deleteItem={deleteItem}
    />
  );
};

export default Sortable;
